import TokenService from '@/helpers/token';
import axios from '@/plugins/axios/index';
import { IKyc, IRegisterUser, IUserResponse } from '../types';
const AUTH_BASE_URL = `${process.env.VUE_APP_API_URL}`;
const APP_API_URL_APP = `${process.env.VUE_APP_API_URL_APP}`;
// call login api
export async function login(params: { email: string; password: string }): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/login`, params);
}
// call apt get me
export async function getMe(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/auth/me`);
}
// call api forgot password
export async function sendEmail(params: { email: string }): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/forgot-password/send-email`, params);
}
// call api forgot password reset
export async function resetPassword(params: {
    password: string;
    password_confirmation: string;
    token: string;
}): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/forgot-password/reset`, params);
}
// call api change password
export async function changePassword(params: {
    old_password: string;
    password: string;
    password_confirmation: string;
}): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/change-password`, params);
}
// call api resgister
export async function register(params: IRegisterUser): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/register`, params);
}

export async function registerApp(params: IRegisterUser): Promise<any> {
    return await axios.post(`${APP_API_URL_APP}/auth/register`, params, {
        headers: {
            'client-os': 'web'
        }
    });
}
// verrify user registed
export async function verifyUserRegisted(params: IUserResponse): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/verify-register`, params);
}
// call resend otp
export async function resendOtp(token: string): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/resend-code`, { token: token });
}
// call log out
export async function logOut(): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/auth/logout`);
}

// call kyc upload
export async function uploadImage(params: { image: string }): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/kyc/upload`, params);
}

export async function uploadKyc(params: IKyc): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/kyc`, params);
}

export async function masterDataCountries(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/master-data?resources[countries]={}`);
}
